import { BUSBUD_POLICY_RULES_URL } from "@app/constants/ancillary";
import { getHepstarRefundLink } from "@app/helpers/ancillary-links";
import { getAncillaryPurchasedItems } from "@app/helpers/purchase/get-ancillary-purchased-items";
import type {
  HepstarRefundProtectionPurchasedAncillaryItem,
  HepstarRefundablePolicy,
  NapiV2Purchase,
  NapiV2PurchasedItem
} from "@app/types/napi-v2-purchase-types";
import { isHepstarRefundProtectionPurchasedAncillaryItem } from "@app/types/napi-v2-purchase-types";

function getPolicyByRulesUrl(
  policies: HepstarRefundablePolicy[] | undefined
): HepstarRefundablePolicy | undefined {
  return policies?.find(
    policy => policy.policy_rules_url === BUSBUD_POLICY_RULES_URL
  );
}

function getHepstarRefundProtectPurchaseItem(
  purchased_items: NapiV2PurchasedItem[]
): HepstarRefundProtectionPurchasedAncillaryItem | undefined {
  return getAncillaryPurchasedItems(purchased_items).find(
    isHepstarRefundProtectionPurchasedAncillaryItem
  );
}

function getHepstarRefundPolicyNumber(purchase: NapiV2Purchase): string {
  const hepstar_refund_protection = getHepstarRefundProtectPurchaseItem(
    purchase.items
  );
  const policy_number: string | undefined = getPolicyByRulesUrl(
    hepstar_refund_protection?.ancillary_details?.policies
  )?.policy_number;

  return policy_number || "";
}

// Safely get the refund link for a given purchase.
export function generateHepstarRefundLink(purchase: NapiV2Purchase): string {
  const booking_reference = getHepstarRefundPolicyNumber(purchase);
  const link = getHepstarRefundLink(booking_reference);
  return link;
}
